import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import { FormErrors, HpButton } from '@hp/ui';
import logoUrl from '@hp/ui/assets/logo.svg';
import { BrandMark } from '../components/brand-mark';

/**
 * Signed-out home. Rendered for EVERY route while unauthenticated — after
 * sign-in the OIDC returnTo brings the user back to the path they wanted.
 */
export default function Landing() {
  const { t } = useTranslation(['shell', 'common']);
  const location = useLocation();
  const authError = new URLSearchParams(location.search).get('auth_error');
  const returnTo = location.pathname === '/' ? '/crm-data' : location.pathname + location.search;
  const loginHref = `/auth/login?returnTo=${encodeURIComponent(returnTo)}`;

  return (
    <div className="bo-landing hp-page">
      <main className="hp-card bo-landing__panel">
        <BrandMark className="bo-landing__mark" />
        <img className="bo-landing__logo" src={logoUrl} width={154} height={28} alt="Home Portal" />
        <h1>{t('common:app.name')}</h1>
        <p>{t('landing.tagline')}</p>
        <FormErrors>
          {authError &&
            (authError === 'account_disabled'
              ? t('landing.accountDisabled')
              : t('landing.signInFailed', { reason: authError }))}
        </FormErrors>
        <HpButton variant="primary" icon="key" onClick={() => window.location.assign(loginHref)}>
          {t('landing.signInWithMicrosoft')}
        </HpButton>
      </main>
      <footer className="bo-landing__foot">{t('landing.footer')}</footer>
    </div>
  );
}
